<template>
  <SelectGroup :options="options"
               variant="white"
               :label="$t('recipient')"
               :required="true"
               :showlabel="true"
               v-model="object.recipient_role_id"/>
</template>

<script setup>
import SelectGroup from "@/components/form/SelectGroup.vue"
import { notificationRoles } from "@/dictionaries/dictionary"
import { computed } from "vue"

defineProps({
  object: {
    type: Object,
  },
})

const options = computed(() => {
  return notificationRoles
})
</script>
